import React, { Component } from 'react';
import PropTypes from 'prop-types';

import PageHeader from '../../../shared/page-header/components/page-header';
import Logo from './logo';
import LogosHelpers from '../helpers/logos-helpers';
import { logo_types } from '../constants/logos-constants';

import '../styles/logos.css';

class Logos extends Component {
  state = {
    type: logo_types.naga,
  };

  renderLogos(items) {
    if (items && items.length > 0) {
      return items.map((item, index) => {
        return <Logo {...item} key={index} />;
      });
    } else return null;
  }

  downloadFile(url) {
    window.open(url, '_blank');
  }

  render() {
    const { t } = this.context;
    const { type } = this.state;
    const content = LogosHelpers.getLogos(type.label, type.value) || {};

    return (
      <div className="logos-container">
        <PageHeader title={'LOGOS.TITLE'} />
        <div className="row">
          <div className="m-b-20 m-t-20 col-md-12">
            <div className="display-flex-vertical m-b-10">
              <p className="logos-container__title">{t(content.title)}</p>
              <div className="transparent-btn flex-pull-right" onClick={() => this.downloadFile(content.zip)}>
                <span>{t('LOGOS.DOWNLOAD_BTN')}</span>
              </div>
            </div>
            <div className="logos-container__wrapper">{this.renderLogos(content.items)}</div>
          </div>
        </div>
      </div>
    );
  }
}

Logos.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default Logos;



// WEBPACK FOOTER //
// ./src/app/main/logos/components/logos.js